import { useEffect, useRef, useState } from 'react'
import { DataTable, DataTableSortOrderType } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IField, ILayer, selectServices, setSelectedLayer, setTableLayer } from '../../features/layerSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import axios from 'axios';
import { Button } from 'primereact/button';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { setFitGeom, setHighlightGeom } from '../../features/mapSlice';
import { setOsbler, setSelectedRow, setShowLoading } from '../../features/sharedSlice';
import { Toast } from 'primereact/toast';
import { setSelectedFeature } from '../../features/selectionSlice';
import './Table.css'
import moment from 'moment';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import ExcelJS from 'exceljs';
import { useTranslation } from 'react-i18next';
import React from 'react';

interface Props {
  layer: ILayer
  raporTable?: boolean
}

interface SortProperties {
  sortField: string,
  sortOrder: DataTableSortOrderType
}

export default function Table(props: Props) {
  const [columns, setColumns] = useState<JSX.Element[]>([])
  const [values, setValues] = useState([]);
  const [sortProperties, setSortProperties] = useState<SortProperties>({
    sortField: 'id',
    sortOrder: 1
  });
  const [selectedTableRow, setSelectedTableRow] = useState<any>();
  const [loading, setLoading] = useState(false);
  const services = useAppSelector(selectServices);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filters, setFilters] = useState<any>({})
  const [usedFilter, setUsedFilter] = useState<any>([])
  const [parcelRaporFilter, setParcelRaporFilter] = useState<any>([])
  const [allFilters, setAllFilters] = useState<any>([])
  const [tapuFilters, setTapuFilters] = useState<any>([])
  const [tapuFilters2, setTapuFilters2] = useState<any>([])
  const [tapuFilters3, setTapuFilters3] = useState<any>([])
  const [domain, setDomain] = useState<any>([])
  const [startTable, setStartTable] = useState<any>(null)
  const dispatch = useAppDispatch();
  const dt = useRef(null);
  const toast = useRef(null);
  const functionalRoles = useAppSelector(state => state.sharedState.functionalRoles);
  const dataRoles = useAppSelector(state => state.sharedState.dataRoles);
  const selectedParcelRapor = useAppSelector(state => state.sharedState.selectedParcelRapor);
  const iller = useAppSelector(state => state.sharedState.iller);
  const ilceler = useAppSelector(state => state.sharedState.ilceler);
  const mahalleler = useAppSelector(state => state.sharedState.mahalleler);
  const tapuIller = useAppSelector(state => state.sharedState.tapuIller);
  const tapuIlceler = useAppSelector(state => state.sharedState.tapuIlceler);
  const tapuMahalleler = useAppSelector(state => state.sharedState.tapuMahalleler);
  const osbler = useAppSelector(state => state.sharedState.osbler);
  const { layer, raporTable } = props;
  const { t } = useTranslation();
  const token = useAppSelector(state => state.authState.token)
  const [tableApiFilters, setTableApiFilters] = useState<any>({ matchMode: '', filterKey: '', value: '' })
  const [sortFilter, setSortFilter] = useState<any>({ sortBy: `${layer.name === 'parsel_usr' || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr' ? 'id' : 'filename'}`, sortOrder: 1 });
  const zoneRoles = useAppSelector(state => state.sharedState.zoneRoles);
  var areaFormatter: any = new Intl.NumberFormat();

  useEffect(() => {
    getOsbler()
    getDomain()
  }, [])

  const getOsbler = async () => {
    const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
    if (serviceUrl) {
      const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&outputFormat=application/json&typeName=osb_sinir_usr&propertyname=adi,id`)
      const osbValues = response.data.features.map(((value: any) => value.properties))
      dispatch(setOsbler(osbValues))
    }
  }

  useEffect(() => {
    if (layer && (layer.name === 'ebler_usr' || layer.name === 'tgb_usr') && zoneRoles && zoneRoles.length > 0) {
      setLoading(true)
      const zoneRoleValues = zoneRoles.map((zoneRoles: any) => zoneRoles.zone_id).join(',')
      setUsedFilter([...usedFilter, { key: 'zone_id', matchMode: ' in ', value: `(${zoneRoleValues})` }])
    }
  }, [layer, zoneRoles])

  useEffect(() => {
    if (layer && layer.name) {
      setSortFilter({ sortBy: `${layer.name === 'uip_1000' || layer.name === 'eb_uip_1000' || layer.name === 'tgb_uip_1000' ? 'filename' : 'id'}`, sortOrder: 1 });
      setTableApiFilters({ matchMode: '', filterKey: '', value: '' })
      setAllFilters([])
      setStartTable(true)
    }

  }, [layer])

  useEffect(() => {
    if (startTable) {
      setLoading(true);
      let tableFields = layer.fields.filter(obj => obj.name !== 'geom')
      if (raporTable) {
        tableFields = tableFields.filter((field: any) => field.name === 'tahsis_sure_uzatim_tarihi' || field.name === 'tahsis_tarihi' || field.name === 'tahsis_bedel_durumu' || field.name === 'tahsis_bedeli' || field.name === 'ada_parsel' || field.name === 'tahsis_iptal_tarihi')
      }

      const columns = []
      const filters: any = {}
      if (layer.name === 'parsel_usr' && !raporTable) {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'osb_adi' ||
          field.name === 'tkgm_il' ||
          field.name === 'tkgm_ilce' ||
          field.name === 'firma_adi' ||
          field.name === 'tkgm_mahalle' ||
          field.name === 'ada' ||
          field.name === 'parsel' ||
          field.name === 'tasinmaz_no' ||
          field.name === 'imar_durumu' ||
          field.name === 'parsel_niteligi' ||
          field.name === 'mulkiyet_durumu' ||
          field.name === 'tahsis_durumu' ||
          field.name === 'asamasi' ||
          field.name === 'parsel_alani')
      }
      if (layer.name === 'parsel_pasif_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'osb_adi' ||
          field.name === 'tkgm_il' ||
          field.name === 'tkgm_ilce' ||
          field.name === 'firma_adi' ||
          field.name === 'ada' ||
          field.name === 'parsel' ||
          field.name === 'tasinmaz_no' ||
          field.name === 'imar_durumu' ||
          field.name === 'parsel_niteligi' ||
          field.name === 'mulkiyet_durumu' ||
          field.name === 'tahsis_durumu' ||
          field.name === 'asamasi' ||
          field.name === 'parsel_alani'
        )
      }
      if (layer.name === 'osb_sinir_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'toplam_sanayi_parseli' ||
          field.name === 'bos_sanayi_parseli' ||
          field.name === 'proje' ||
          field.name === 'insaat' ||
          field.name === 'uretim' ||
          field.name === 'il_adi' ||
          field.name === 'ilce_adi' ||
          field.name === 'adi' ||
          field.name === 'osb_turu' ||
          field.name === 'alan' ||
          field.name === 'sicil_no' ||
          field.name === 'osb_kurulus_tarihi')
      }
      if (layer.name === 'ebler_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'il_kodu' ||
          field.name === 'ilce_kodu' ||
          field.name === 'adi' ||
          field.name === 'eb_turu' ||
          field.name === 'alan' ||
          field.name === 'resmi_gazete_tarihi' ||
          field.name === 'yonetici_sirket' ||
          field.name === 'sektor'
        )
      }
      if (layer.name === 'tgb_usr') {

        tableFields = tableFields.filter((field: any) =>
          field.name === 'il_kodu' ||
          field.name === 'ilce_kodu' ||
          field.name === 'adi' ||
          field.name === 'alan' ||
          field.name === 'resmi_gazete_tarihi' ||
          field.name === 'yonetici_sirket' ||
          field.name === 'ilan_tarihi'
        )
      }
      if (layer.name === 'ilce_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'adi' ||
          field.name === 'il_kodu'
        )
      }
      if (layer.name === 'karayolu_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'adi')
      }
      if (layer.name === 'demiryolu_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'adi')
      }
      if (layer.name === 'havalimani_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'adi')
      }
      if (layer.name === 'liman_usr') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'adi')
      }
      if (layer.name === 'uip_1000') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'onay_tarihi' ||
          field.name === 'osb_adi' ||
          field.name === 'plan_niteligi' ||
          field.name === 'planadi' ||
          field.name === 'buyukluk')
      }
      if (layer.name === 'eb_uip_1000') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'onay_tarihi' ||
          field.name === 'eb_adi' ||
          field.name === 'plan_niteligi' ||
          field.name === 'planadi' ||
          field.name === 'buyukluk')
      }
      if (layer.name === 'tgb_uip_1000') {
        tableFields = tableFields.filter((field: any) =>
          field.name === 'onay_tarihi' ||
          field.name === 'tgb_adi' ||
          field.name === 'plan_niteligi' ||
          field.name === 'planadi' ||
          field.name === 'buyukluk'
        )
      }

      for (const field of tableFields) {
        if (layer.name) {
          switch (field.type) {
            case 'Text':
              filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
              columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
              break;
            case 'Boolean':
              if (field.name !== 'active') {
                filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
                columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
              }
              break;
            case 'Area':
              filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
              columns.push(<Column filter dataType="numeric" filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
              break;
            case 'CreatedDate':
              if (layer.name !== 'cografi_bolge_usr' && layer.name !== 'tesvik_bolgeleri_usr' && layer.name !== 'istatistik_bolge_duzey_2_usr' && layer.name !== 'il_usr' && layer.name !== 'ilce_usr') {
                filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
                columns.push(<Column filter dataType="date" filterField={field.name} sortable key={field.id} field={field.name} header={field.alias}
                  body={(rowData) => { return dateBodyTemplate(rowData, field.name) }} filterElement={dateFilterTemplate} />)
              }
              break;
            case 'TouchDate':
              if (layer.name !== 'cografi_bolge_usr' && layer.name !== 'tesvik_bolgeleri_usr' && layer.name !== 'istatistik_bolge_duzey_2_usr' && layer.name !== 'il_usr' && layer.name !== 'ilce_usr') {
                filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
                columns.push(<Column filter dataType="date" filterField={field.name} sortable key={field.id} field={field.name} header={field.alias}
                  body={(rowData) => { return dateBodyTemplate(rowData, field.name) }} filterElement={dateFilterTemplate} />)
              }
              break;
            case 'Date':
              filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
              columns.push(<Column filter dataType="date" filterField={field.name} sortable key={field.id} field={field.name} header={field.alias}
                body={(rowData) => { return dateBodyTemplate(rowData, field.name) }} filterElement={dateFilterTemplate} />)
              break;
            case 'Domain':
              columns.push(<Column filter showFilterMatchModes={false} sortable key={field.id} field={field.name} header={field.alias}
                filterElement={(options) => { return domainFilterTemplate(options, field) }} />)
              filters[field.name] = { value: null, matchMode: FilterMatchMode.IN }
              break;
            case 'CreatedBy':
              if (layer.name !== 'cografi_bolge_usr' && layer.name !== 'tesvik_bolgeleri_usr' && layer.name !== 'istatistik_bolge_duzey_2_usr' && layer.name !== 'il_usr' && layer.name !== 'ilce_usr') {
                filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
                columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
              }
              break;
            case 'TouchBy':
              if (layer.name !== 'cografi_bolge_usr' && layer.name !== 'tesvik_bolgeleri_usr' && layer.name !== 'istatistik_bolge_duzey_2_usr' && layer.name !== 'il_usr' && layer.name !== 'ilce_usr') {
                filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
                columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
              }
              break;
            case 'Id':
              if (layer.name !== 'cografi_bolge_usr' && layer.name !== 'tesvik_bolgeleri_usr' && layer.name !== 'istatistik_bolge_duzey_2_usr' && layer.name !== 'il_usr' && layer.name !== 'ilce_usr') {
                filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
                columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
              }
              break;
            case 'Integer':
              if (field.name === 'sb_id' || field.name === 'il_kodu' || field.name === 'ilce_kodu' || field.name === 'mahalle_kodu' || field.name === 'tkgm_il_kodu' || field.name === 'tkgm_ilce_kodu' || field.name === 'tkgm_mahalle_kodu') {
                filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
                columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
              }
              else {
                if (layer.name === 'il_usr' && field.name !== 'kodu') {
                  filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
                  columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
                }
                if (layer.name !== 'il_usr') {
                  filters[field.name] = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
                  columns.push(<Column filter filterField={field.name} sortable key={field.id} field={field.name} header={field.alias} />)
                }
              }
              break;
            default:
              columns.push(<Column sortable key={field.id} filter filterField={field.name} field={field.name} header={field.alias} />)
              break;
          }
        }

      }
      setColumns(columns);
      setFilters(filters);
      if (layer.name === 'ebler_usr' || layer.name === 'tgb_usr') {
        if (allFilters.length > 0) {
          loadLazyData();
        }
      }
      else {
        loadLazyData();
      }
    }
    return () => setStartTable(false)

  }, [startTable])


  const gotoSelectionHandler = async () => {
    dispatch(setSelectedRow(true))
    if (selectedTableRow) {
      if (layer.name === 'uip_1000') {
        const osbId = selectedTableRow.osb
        axios.get(process.env.REACT_APP_BASE_URL +
          `rest/v1/geoserver/osb/ows?service=WFS&version=1.0.0&crsName=EPSG:4326&request=getfeature&token=${token}&cql_filter=osb=${osbId}&typeName=uip_1000&outputFormat=application/json`
        ).then((res) => {
          const features = res.data.features.map((feature: any) => feature.geometry.geometries[0]);
          dispatch(setHighlightGeom(features[0]))
          dispatch(setFitGeom(features[0]))
          dispatch(setSelectedLayer(layer))
        })
      }
      else if (layer.name === 'tgb_uip_1000') {
        const tgbId = selectedTableRow.tgb;
        axios.get(process.env.REACT_APP_BASE_URL +
          `rest/v1/geoserver/osb/ows?service=WFS&version=1.0.0&crsName=EPSG:4326&request=getfeature&token=${token}&cql_filter=tgb=${tgbId}&typeName=tgb_uip_1000&outputFormat=application/json`
        ).then((res) => {
          const features = res.data.features.map((feature: any) => feature.geometry.geometries[0]);
          dispatch(setHighlightGeom(features[0]))
          dispatch(setFitGeom(features[0]))
          dispatch(setSelectedLayer(layer))
        })
      }
      else if (layer.name === 'eb_uip_1000') {
        const ebId = selectedTableRow.eb;
        axios.get(process.env.REACT_APP_BASE_URL +
          `rest/v1/geoserver/osb/ows?service=WFS&version=1.0.0&crsName=EPSG:4326&request=getfeature&token=${token}&cql_filter=eb=${ebId}&propertyName=geom&typeName=eb_uip_1000&outputFormat=application/json`
        ).then((res) => {
          const features = res.data.features.map((feature: any) => feature.geometry.geometries[0]);
          dispatch(setHighlightGeom(features[0]))
          dispatch(setFitGeom(features[0]))
          dispatch(setSelectedLayer(layer))
        })
      }
      else {
        const service = services.find(service => { return service.layers.some(layerObj => layerObj.name === layer.name) })
        if (service) {
          try {
            const response = await axios.get(service!.url + `/ows?service=WFS&version=1.0.0&crsName=EPSG:4326&request=getfeature` + (token ? `&token=${token}` : '') + `&featureId=${selectedTableRow.id}&typeName=${layer.name === 'parsel_pasif_usr' ? 'parsel_usr' : layer.name}&outputFormat=application/json`)
            const feature :any = response.data.features[0]
            dispatch(setSelectedFeature(feature));
          } catch (error) {
            console.log(error);
          }
        }
      }
    }
  }

  const clearSelectionHandler = () => {
    setSelectedTableRow(null);
    dispatch(setFitGeom(null));
    dispatch(setHighlightGeom(null));
    dispatch(setSelectedFeature(null));
  }

  const exportPdf = () => {
    dispatch(setShowLoading(true));
    try {
      const unit = "mm";
      const size = "A4"; // Use A1, A2, A3 or A4
      const orientation = "l";
      const doc = new jsPDF(orientation, unit, size)
      doc.setFontSize(8);
      doc.addFont('OpenSans-Regular.ttf', 'OpenSans-Regular', 'normal');
      doc.setFont('OpenSans-Regular');

      const valueArray = values.map((obj: any) => Object.values(obj).map(value => { return value ? value : '' }));

      autoTable(doc, { startY: 20, margin: 20, head: [Object.keys(values[0])], theme: 'grid', body: valueArray as any })
      doc.save('table.pdf');
      dispatch(setShowLoading(false));
    } catch (error) {
      console.log(error);
      (toast.current as any).show({ severity: 'error', summary: 'Error Message', detail: 'Tablo cant be export' });
      dispatch(setShowLoading(false));
    }
  }

  const exportExcel = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    format: "xlsx" | "csv"
  ) => {
    e.preventDefault();
    let tableFields;
    dispatch(setShowLoading(true))
    const serviceFind = services.find(service => service.id === layer.service_id);
    const layerPerm = dataRoles.find((obj: any) => obj.layer_id === layer.id && obj.field_id === null)
    if (layerPerm) {
      tableFields = layer.fields.filter(obj => obj.name !== 'geom' && obj.type !== 'Attachment')
    } else {
      const layerPerm = dataRoles.filter((obj: any) => obj.layer_id === layer.id)
      const fieldIds = layerPerm.map((obj: any) => obj.field_id)
      tableFields = layer.fields.filter(obj => fieldIds.includes(obj.id) && obj.name !== 'geom' && obj.type !== 'Attachment');
    }
    const properties = tableFields.map(field => field.name).join(',')

    let allResults;
    let allFeatures;


    if (layer.name === 'parsel_usr' || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr') {
      const layerName = layer.name.substring(0, layer.name.length - 4)
      allResults = await axios.get(process.env.REACT_APP_BASE_URL +
        `rest/v1/inventory/${layerName === 'parsel_pasif' ? 'parsel' : layerName}/100000/0/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}`, { params: { token: token, passive: layer.name === 'parsel_pasif_usr' ? true : null }, })
      allFeatures = allResults.data.data;
    }
    else if (layer.name === 'uip_1000') {
      allResults = await axios.get(process.env.REACT_APP_BASE_URL +
        `rest/v1/plan-gml/osb/100000/0/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}`, { params: { token: token }, })
      allFeatures = allResults.data.plan;
    }
    else if (layer.name === 'tgb_uip_1000') {
      allResults = await axios.get(process.env.REACT_APP_BASE_URL +
        `rest/v1/plan-gml/tgb/100000/0/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}`, { params: { token: token }, })
      allFeatures = allResults.data.plan;
    }
    else if (layer.name === 'eb_uip_1000') {
      allResults = await axios.get(process.env.REACT_APP_BASE_URL +
        `rest/v1/plan-gml/eb/100000/0/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}`, { params: { token: token }, })
      allFeatures = allResults.data.plan;
    }
    else {
      allResults = await axios.get(serviceFind!.url +
        `/ows?service=WFS&${allFilters && allFilters.length > 0 && `cql_filter=${allFilters.map((element: any) => `(${element.key}${element.matchMode}${element.value})`).join(' AND ')}`}&sortBy=${sortProperties.sortField + (sortProperties.sortOrder === 1 ? '+A' : '+D')}&version=1.0.0&request=getfeature&token=${token}&propertyName=${properties}&typeName=${layer.name}&outputFormat=application/json`)
      allFeatures = allResults.data.features
    }


    let fields = layer.fields.filter(obj => obj.name !== 'geom');
    if (layer.name === 'parsel_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'osb_adi' ||
        field.name === 'tkgm_il' ||
        field.name === 'tkgm_ilce' ||
        field.name === 'firma_adi' ||
        field.name === 'tkgm_mahalle' ||
        field.name === 'ada' ||
        field.name === 'parsel' ||
        field.name === 'tasinmaz_no' ||
        field.name === 'imar_durumu' ||
        field.name === 'parsel_niteligi' ||
        field.name === 'mulkiyet_durumu' ||
        field.name === 'tahsis_durumu' ||
        field.name === 'asamasi' ||
        field.name === 'parsel_alani'
      )
    }
    if (layer.name === 'parsel_pasif_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'osb_adi' ||
        field.name === 'tkgm_il' ||
        field.name === 'tkgm_ilce' ||
        field.name === 'firma_adi' ||
        field.name === 'ada' ||
        field.name === 'parsel' ||
        field.name === 'tasinmaz_no' ||
        field.name === 'imar_durumu' ||
        field.name === 'parsel_niteligi' ||
        field.name === 'mulkiyet_durumu' ||
        field.name === 'tahsis_durumu' ||
        field.name === 'asamasi' ||
        field.name === 'parsel_alani'
      )
    }
    if (layer.name === 'osb_sinir_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'toplam_sanayi_parseli' ||
        field.name === 'bos_sanayi_parseli' ||
        field.name === 'proje' ||
        field.name === 'insaat' ||
        field.name === 'uretim' ||
        field.name === 'il_adi' ||
        field.name === 'ilce_adi' ||
        field.name === 'adi' ||
        field.name === 'osb_turu' ||
        field.name === 'alan' ||
        field.name === 'sicil_no' ||
        field.name === 'osb_kurulus_tarihi'
      )
    }
    if (layer.name === 'ebler_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'il_kodu' ||
        field.name === 'ilce_kodu' ||
        field.name === 'adi' ||
        field.name === 'eb_turu' ||
        field.name === 'alan' ||
        field.name === 'resmi_gazete_tarihi' ||
        field.name === 'yonetici_sirket' ||
        field.name === 'sektor'
      )
    }
    if (layer.name === 'tgb_usr') {

      fields = fields.filter((field: any) =>
        field.name === 'il_kodu' ||
        field.name === 'ilce_kodu' ||
        field.name === 'adi' ||
        field.name === 'alan' ||
        field.name === 'resmi_gazete_tarihi' ||
        field.name === 'yonetici_sirket' ||
        field.name === 'ilan_tarihi'
      )
    }
    if (layer.name === 'il_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'adi' ||
        field.name === 'osb_sayisi' ||
        field.name === 'dolu_sanayi_parseli' ||
        field.name === 'bos_sanayi_parseli' ||
        field.name === 'proje' ||
        field.name === 'insaat' ||
        field.name === 'uretim'
      )
    }
    if (layer.name === 'ilce_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'adi' ||
        field.name === 'il_kodu'
      )
    }
    if (layer.name === 'karayolu_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'adi')
    }
    if (layer.name === 'demiryolu_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'adi')
    }
    if (layer.name === 'havalimani_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'adi')
    }
    if (layer.name === 'liman_usr') {
      fields = fields.filter((field: any) =>
        field.name === 'adi')
    }
    if (layer.name === 'uip_1000') {
      fields = fields.filter((field: any) =>
        field.name === 'onay_tarihi' ||
        field.name === 'osb_adi' ||
        field.name === 'plan_niteligi' ||
        field.name === 'planadi' ||
        field.name === 'buyukluk')
    }
    if (layer.name === 'eb_uip_1000') {
      fields = fields.filter((field: any) =>
        field.name === 'onay_tarihi' ||
        field.name === 'eb_adi' ||
        field.name === 'plan_niteligi' ||
        field.name === 'planadi' ||
        field.name === 'buyukluk')
    }
    if (layer.name === 'tgb_uip_1000') {
      fields = fields.filter((field: any) =>
        field.name === 'onay_tarihi' ||
        field.name === 'tgb_adi' ||
        field.name === 'plan_niteligi' ||
        field.name === 'planadi' ||
        field.name === 'buyukluk'
      )
    }

    const values2: any = [];

    for (const feature of allFeatures) {
      const properties: any = {}
      for (const field of fields) {
        let propt: any;
        if (layer.name === 'parsel_usr' || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr' || layer.name === 'uip_1000' || layer.name === 'eb_uip_1000' || layer.name === 'tgb_uip_1000') {
          propt = feature
        }
        else {
          propt = feature.properties
        }
        switch (field.type) {
          case 'Domain':
            properties[field.name] = field.domain?.find(obj => obj.id === propt[field.name])?.desc;
            break;
          case 'CreatedDate':
            properties[field.name] = propt[field.name] ? new Date(propt[field.name]) : '';
            break;

          case 'Date':
            properties[field.name] = propt[field.name] ? new Date(propt[field.name]) : '';
            break;
          case 'Area':
            properties[field.name] = propt[field.name] ? areaFormatter.format(propt[field.name].toFixed(2)) : '';
            if (properties[field.name]) {
              const split = properties[field.name].split(',')
              if (split[1] && split[1].length === 1) {
                properties[field.name] = properties[field.name] + '0'
              }
              if (!split[1]) {
                properties[field.name] = properties[field.name] + ',00'
              }
            }
            break;
          case 'Float':
            properties[field.name] = propt[field.name] ? areaFormatter.format(propt[field.name].toFixed(2)) : '';
            break;
          default:
            properties[field.name] = propt[field.name];
            break;
        }
      }
      values2.push(properties)
    }


    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet(layer.alias);
    const worksheet = workbook.getWorksheet(layer.alias);

    //başlıklar
    worksheet.columns =
      fields.map((layer: any) => {
        return {
          header: layer.alias, key: layer.name, width: 20
        }
      })

    // başlık dışındaki satırlar
    if (values2.length === 0) {
      //tüm datalar export olcak
      for (const data of allFeatures) {
        worksheet.addRow(data);
      }
    } else if (values2.length > 0) {
      for (const data of values2) {
        worksheet.addRow(data);
      }
    }

    // Sayfadaki ilk satırın (sütun başlıkları) kalın olmasını sağlar
    worksheet.getRow(1).font = { bold: true }
    // Sayfadaki ilk satırın (sütun başlıkları) ortada hizalanmasını sağlar.
    worksheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' }
    worksheet.getRow(1).height = 30
    worksheet.getRow(1).border = {
      top: { style: 'thick' },
      left: { style: 'thick' },
      right: { style: 'thick' },
      bottom: { style: 'thick' },
    }

    const uint8Array =
      format === "xlsx"
        ? await workbook.xlsx.writeBuffer()
        : await workbook.csv.writeBuffer();
    const blob = new Blob([uint8Array], { type: "application/octet-binary" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${layer.alias}.` + format;
    a.click();
    a.remove();
  };

  const getDomain = async () => {
    const response = await axios(`${process.env.REACT_APP_BASE_URL}rest/v1/domain/10713/options?token=${token}`)
    setDomain(response.data.options);
  }

  const header = (
    <>
      {!raporTable &&
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '23px' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 className='table-header'>{layer.alias}</h3>
            <Button className="p-button-outlined" style={{ marginRight: '10px' }} disabled={!selectedTableRow} label={t('BUTTON.Go to Selected Data')} onClick={gotoSelectionHandler} />
            <Button className="p-button-outlined p-button-help" style={{ marginRight: '10px' }} label={t('BUTTON.Clear Selection')} onClick={clearSelectionHandler} />
            {functionalRoles.findIndex((role: any) => role.function_id === 14) > -1 &&
              <>
                <Button className="p-button-outlined p-button-success" style={{ marginRight: '10px' }} label={t('BUTTON.Export CSV')} type="button" onClick={(e) => exportExcel(e, "csv")} />
                <Button className="p-button-outlined p-button-secondary" style={{ marginRight: '10px' }} label={t('BUTTON.Export PDF')} type="button" onClick={() => exportPdf()} />
                {functionalRoles.findIndex((role: any) => role.function_id === 20) > -1 && <Button className="p-button-outlined p-button-danger" style={{ marginRight: '10px' }} label={t('BUTTON.Export Excel')} type="button" onClick={(e) => exportExcel(e, "xlsx")} />
                }          </>
            }
          </div>
          <Button icon="pi pi-times" className="p-button-rounded p-button-text" aria-label="Cancel" onClick={() => { dispatch(setTableLayer(undefined)) }} />
        </div>
      }
      {
        raporTable && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignItems: 'center', height: '23px' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            {functionalRoles.findIndex((role: any) => role.function_id === 14) > -1 &&
              <>
                {functionalRoles.findIndex((role: any) => role.function_id === 20) > -1 && <Button className="p-button-outlined p-button-danger" style={{ marginRight: '10px' }} label={t('BUTTON.Export Excel')} type="button" onClick={(e) => exportExcel(e, "xlsx")} />
                }
              </>
            }
          </div>
        </div>
      }</>
  );

  const dateBodyTemplate = (rowData: any, field_name: string) => {
    return rowData[field_name] ? moment(rowData[field_name]).format('DD.MM.YYYY') : undefined;
  }

  const formatDate = (value: any) => {
    const date = new Date(value)
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  const dateFilterTemplate = (options: any) => {
    return <Calendar value={options.value} onChange={(e) => options.filterCallback(formatDate(e.value), options.index)} dateFormat="dd/mm/yy" placeholder={`${moment().format('DD.MM.YYYY')}`} mask="99/99/9999" />
  }

  const domainFilterTemplate = (options: any, field: IField) => {
    return <MultiSelect value={options.value} options={field.domain?.map(obj => { return { label: obj.desc, value: obj.id } })} onChange={(e) => { options.filterCallback(e.value); }} />
  }

  const zart = <div>{t('TEXT.Total Record')} : {totalRecords}</div>

  useEffect(() => {
    if (rows && first !== undefined) {
      if (layer.name === 'ebler_usr' || layer.name === 'tgb_usr') {
        if (allFilters.length > 0) {
          loadLazyData();
        }
      }
      else {
        loadLazyData()
      }
    }
  }, [rows, first, sortProperties, selectedParcelRapor, allFilters, domain, sortFilter, tableApiFilters, currentPage])

  useEffect(() => {
    if ((tapuFilters && tapuFilters.length > 0) || (tapuFilters2 && tapuFilters2.length > 0)) {
      setTimeout(() => {
        setAllFilters([...usedFilter, ...parcelRaporFilter, ...tapuFilters, ...tapuFilters2, ...tapuFilters3])
      }, 500);
    }
    else {
      setAllFilters([...usedFilter, ...parcelRaporFilter, ...tapuFilters, ...tapuFilters2, ...tapuFilters3])
    }
  }, [parcelRaporFilter, usedFilter, tapuFilters, tapuFilters2, tapuFilters3])

  const loadLazyData = async () => {
    const serviceFind = services.find(service => service.id === layer.service_id);
    setLoading(true)
    if (serviceFind) {
      let tableFields;
      const layerPerm = dataRoles.find((obj: any) => obj.layer_id === layer.id && obj.field_id === null)
      if (layerPerm) {
        tableFields = layer.fields.filter(obj => obj.name !== 'geom' && obj.type !== 'Attachment')
      } else {
        const layerPerm = dataRoles.filter((obj: any) => obj.layer_id === layer.id)
        const fieldIds = layerPerm.map((obj: any) => obj.field_id)
        tableFields = layer.fields.filter(obj => fieldIds.includes(obj.id) && obj.name !== 'geom' && obj.type !== 'Attachment');
      }
      let properties = tableFields.map(field => field.name).join(',')

      let features: any;
      let result: any;
      let score: any;
      let values: any = [];

      try {
        if (layer.name === 'uip_1000') {
          if (domain && domain.length > 0) {
            const planResponse = await axios(`${process.env.REACT_APP_BASE_URL}rest/v1/plan-gml/osb/${rows}/${first}/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}/?token=${token}`)
            const plan = planResponse.data.plan;
            features = planResponse.data.plan;
            values = plan.map((value: any) => value = { ...value, plan_niteligi: domain.find((dom: any) => dom.id === +value.plan_niteligi).desc })
            score = planResponse.data.totalCount;
            setLoading(false)
            setValues(values);
            setTotalRecords(score);
          }
        }
        else if (layer.name === 'eb_uip_1000') {
          if (domain && domain.length > 0) {
            const planResponse = await axios(`${process.env.REACT_APP_BASE_URL}rest/v1/plan-gml/eb/${rows}/${first}/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}/?token=${token}`)
            const plan = planResponse.data.plan;
            features = planResponse.data.plan;
            values = plan.map((value: any) => value = { ...value, plan_niteligi: domain.find((dom: any) => dom.id === +value.plan_niteligi).desc })
            score = planResponse.data.totalCount;
            setLoading(false)
            setValues(values);
            setTotalRecords(score);
          }
        }
        else if (layer.name === 'tgb_uip_1000') {
          if (domain && domain.length > 0) {
            const planResponse = await axios(`${process.env.REACT_APP_BASE_URL}rest/v1/plan-gml/tgb/${rows}/${first}/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}/?token=${token}`)
            const plan = planResponse.data.plan;
            features = planResponse.data.plan;
            values = plan.map((value: any) => value = { ...value, plan_niteligi: domain.find((dom: any) => dom.id === +value.plan_niteligi).desc })
            score = planResponse.data.totalCount;
            setLoading(false)
            setValues(values);
            setTotalRecords(score);
          }
        }
        else if ((layer.name === 'parsel_usr' && !raporTable) || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr') {
          //özel
          const layerName = layer.name.substring(0, layer.name.length - 4)
          result = await axios.get(process.env.REACT_APP_BASE_URL +
            `rest/v1/inventory/${layerName === 'parsel_pasif' ? 'parsel' : layerName}/${rows}/${first}/${sortFilter.sortBy}/${sortFilter.sortOrder}${tableApiFilters && tableApiFilters.filterKey ? `/${tableApiFilters.matchMode}/${tableApiFilters.filterKey}/${tableApiFilters.value}` : ''}`, { params: { token: token, passive: layer.name === 'parsel_pasif_usr' ? true : null }, })
          features = result.data.data;
          score = result.data.totalCount;
          const fields = layer.fields.filter(obj => obj.name !== 'geom');


          if (features.length > 0) {
            for (const feature of features) {
              const properties: any = {}
              for (const field of fields) {
                switch (field.type) {
                  case 'Domain':
                    properties[field.name] = field.domain?.find(obj => obj.id === feature[field.name])?.desc;
                    break;
                  case 'CreatedDate':
                    properties[field.name] = feature[field.name] ? new Date(feature[field.name]) : '';
                    break;
                  case 'Area':
                    properties[field.name] = feature[field.name] ? areaFormatter.format(feature[field.name].toFixed(2)) : '';
                    const split = properties[field.name].split(',')
                    if (split[1] && split[1].length === 1) {
                      properties[field.name] = properties[field.name] + '0'
                    }
                    if (split[0] && !split[1]) {
                      properties[field.name] = properties[field.name] + ',00'
                    }
                    break;
                  case 'Float':
                    properties[field.name] = feature[field.name] ? areaFormatter.format(feature[field.name].toFixed(2)) : '';
                    break;
                  default:
                    properties[field.name] = feature[field.name];
                    break;
                }
              }
              values.push(properties)
            }
          }
          else {
            values = []
          }
          setTimeout(() => {
            setLoading(false)
            setValues(values);
            setTotalRecords(score);
          }, 500);
        }
        else {


          result = await axios.get(serviceFind!.url +
            `/ows?service=WFS&maxFeatures=${rows}&startIndex=${first}&${allFilters && allFilters.length > 0 && `cql_filter=${allFilters.map((element: any) => `(${element.key}${element.matchMode}${element.value})`).join(' AND ')}`}&sortBy=${sortProperties.sortField + (sortProperties.sortOrder === 1 ? '+A' : '+D')}&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&propertyName=${properties}&typeName=${layer.name}&outputFormat=application/json`)
          features = result.data.features;
          score = result.data.totalFeatures;
          const fields = layer.fields.filter(obj => obj.name !== 'geom');

          if (features.length > 0) {
            for (const feature of features) {
              const properties: any = {}
              for (const field of fields) {
                switch (field.type) {
                  case 'Domain':
                    properties[field.name] = field.domain?.find(obj => obj.id === feature.properties[field.name])?.desc;
                    break;
                  case 'CreatedDate':
                    if (layer.name !== 'cografi_bolge_usr' && layer.name !== 'tesvik_bolgeleri_usr' && layer.name !== 'istatistik_bolge_duzey_2_usr' && layer.name !== 'il_usr' && layer.name !== 'ilce_usr') {
                      properties[field.name] = feature.properties[field.name] ? new Date(feature.properties[field.name]) : '';
                    }
                    break;

                  case 'Area':
                    properties[field.name] = feature.properties[field.name] ? areaFormatter.format(feature.properties[field.name].toFixed(2)) : '';
                    const split = properties[field.name].split(',')
                    if (split[1] && split[1].length === 1) {
                      properties[field.name] = properties[field.name] + '0'
                    }
                    if (!split[1]) {
                      properties[field.name] = properties[field.name] + ',00'
                    }
                    break;
                  case 'Float':
                    properties[field.name] = feature.properties[field.name] ? areaFormatter.format(feature.properties[field.name].toFixed(2)) : '';
                    break;
                  default:
                    properties[field.name] = feature.properties[field.name];
                    break;
                }

                if (field.name === 'tkgm_il_kodu') {
                  properties['tkgm_il_kodu'] = tapuIller.find((obj: any) => obj.id === properties['tkgm_il_kodu'])?.ad;
                }
                if (field.name === 'tkgm_ilce_kodu') {
                  properties['tkgm_ilce_kodu'] = tapuIlceler.find((obj: any) => obj.id === properties['tkgm_ilce_kodu'])?.ad;
                }
                if (field.name === 'tkgm_mahalle_kodu') {
                  properties['tkgm_mahalle_kodu'] = tapuMahalleler.find((obj: any) => obj.id === properties['tkgm_mahalle_kodu'])?.ad;
                }
                //il_usrden gelecek
                if (field.name === 'il_kodu') {
                  properties['il_kodu'] = iller.find((obj: any) => obj.id === properties['il_kodu'])?.adi;
                }
                if (field.name === 'ilce_kodu') {
                  properties['ilce_kodu'] = ilceler.find((obj: any) => obj.ilce_kodu === properties['ilce_kodu'])?.adi;
                }
                if (field.name === 'mahalle_kodu') {
                  properties['mahalle_kodu'] = mahalleler.find((obj: any) => obj.mah_id === properties['mahalle_kodu'])?.adi;
                }
                if (field.name === 'sb_id') {
                  properties['sb_id'] = osbler.find((obj: any) => obj.id === properties['sb_id'])?.adi;
                }
              }
              values.push(properties)
            }

          }
          else {
            values = []

          }
          setTimeout(() => {
            setLoading(false)
            setValues(values);
            setTotalRecords(score);
          }, 500);
        }

      } catch (error) {
        setLoading(false);
        setValues([])
        setTotalRecords(0)
      }
    } else {
      setLoading(false);
    }

  }

  useEffect(() => { 
    if (selectedParcelRapor) { 
      const currentDate = new Date(); 
      const currentDate2 = new Date();
      currentDate2.setFullYear(currentDate2.getFullYear() - 1);

      let localDateTime = moment(currentDate).format('YYYY-MM-DDTHH:mm:ss');
      setParcelRaporFilter([])
      switch (selectedParcelRapor.name) {
        case 'Tümü':
          setParcelRaporFilter([])
          break;
        case 'Proje Aşamasında':
          setParcelRaporFilter([{ key: 'asamasi', matchMode: '=', value: `1` }])
          break;
        case 'Proje Süresi Geçenler':
          setParcelRaporFilter([
            { key: 'asamasi', matchMode: '=', value: `1` },
            { key: 'tahsis_sure_uzatim_tarihi', matchMode: ' is ', value: `null` },
            { key: 'tahsis_tarihi', matchMode: '<', value: `'${localDateTime + 'Z'}'` },
          ]);
          break;
        case 'Proje Uzatma Süresi Alanlar':
          setParcelRaporFilter([{ key: 'tahsis_sure_uzatim_tarihi', matchMode: '>', value: `'${localDateTime + 'Z'}'` }, { key: 'asamasi', matchMode: '=', value: `1` }]);
          break;
        case 'İnşaat Aşamasında':
          setParcelRaporFilter([{ key: 'asamasi', matchMode: '=', value: `2` }])
          break;
        case 'İnşaat Süresi Geçenler':
          setParcelRaporFilter([{ key: ' ruhsat_sure_uzatim_tarihi', matchMode: '<', value: `'${localDateTime + 'Z'}'` }, { key: 'asamasi', matchMode: '=', value: `2` }]);
          break;
        case 'İnşaat Uzatma Süresi Alanlar':
          setParcelRaporFilter([{ key: ' ruhsat_sure_uzatim_tarihi', matchMode: '>', value: `'${localDateTime + 'Z'}'` }, { key: 'asamasi', matchMode: '=', value: `2` }]);
          break;
        case 'Üretim Aşamasında':
          setParcelRaporFilter([{ key: 'asamasi', matchMode: '=', value: `3` }])
          break;
        default:
          break;
      }
    }
  }, [selectedParcelRapor])

  const onPage = (event: any) => {
    setRows(event.rows);
    setFirst(event.first);
    setCurrentPage(event.page + 1);
  }

  const onSort = (event: any) => {
    if (layer.name === 'parsel_usr' || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr' || layer.name === 'uip_1000' || layer.name === 'eb_uip_1000' || layer.name === 'tgb_uip_1000') {
      setSortFilter({ sortOrder: event.sortOrder === -1 ? 0 : 1, sortBy: event.sortField })
    }
    else {
      setSortProperties({ sortField: event.sortField, sortOrder: event.sortOrder })
    }
  }

  const onFilter = async (event: any) => {

    const filters = event.filters;
    const allFilters: any = []

    for (const [key, value] of Object.entries(filters)) {
      allFilters.push({ key, value })
    }


    if ((layer.name === 'parsel_usr' && !raporTable) || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr' || layer.name === 'uip_1000' || layer.name === 'eb_uip_1000' || layer.name === 'tgb_uip_1000') {
      const result = createFilters2(allFilters)
      setTableApiFilters(result);
    }
    else {
      const result = createFilters(allFilters)

      const ilIlceMahFilters = result.filter((filter: any) => filter.key === 'il_kodu' || filter.key === 'ilce_kodu' || filter.key === 'mahalle_kodu')
      const tkgmFilters = result.filter((filter: any) => filter.key === 'tkgm_il_kodu' || filter.key === 'tkgm_ilce_kodu' || filter.key === 'tkgm_mahalle_kodu')
      const sbFilter = result.filter((filter: any) => filter.key === 'sb_id')
      const otherFilters = result.filter((filter: any) => filter.key !== 'sb_id' && filter.key !== 'il_kodu' && filter.key !== 'ilce_kodu' && filter.key !== 'mahalle_kodu' && filter.key !== 'tkgm_il_kodu' && filter.key !== 'tkgm_ilce_kodu' && filter.key !== 'tkgm_mahalle_kodu')

      const res = await searchInTapu(ilIlceMahFilters)
      const res2 = await searchInTkgm(tkgmFilters)
      const res3 = await searchInSb(sbFilter)
      setTapuFilters(res)
      setTapuFilters2(res2)
      setTapuFilters3(res3)

      setUsedFilter(otherFilters);
    }
  }

  const createFilters = (allFilters: any) => {
    const usedFilters: any = []

    if (allFilters.length > 0) {
      allFilters.forEach((filter: any) => {
        if (filter.value.constraints && filter.value.constraints.length > 0) {
          filter.value.constraints.forEach((item: any) => {
            if (item.value) {
              if (item.matchMode === 'startsWith') {
                usedFilters.push({ key: filter.key, matchMode: ' like ', value: `'${item.value}%25'` });
              }
              if (item.matchMode === 'contains') {
                usedFilters.push({ key: filter.key, matchMode: ' like ', value: `'%25${item.value}%25'` });
              }
              if (item.matchMode === 'notContains') {
                usedFilters.push({ key: filter.key, matchMode: ' not like ', value: `'%25${item.value}%25'` });
              }
              if (item.matchMode === 'endsWith') {
                usedFilters.push({ key: filter.key, matchMode: ' like ', value: `'%25${item.value}'` });
              }
              if (item.matchMode === 'equals') {
                usedFilters.push({ key: filter.key, matchMode: '=', value: `'${item.value}'` });
              }
              //for dates
              if (item.matchMode === 'dateIs') {
                let localDateTime = moment(item.value).format('YYYY-MM-DDTHH:mm:ss');
                usedFilters.push({ key: filter.key, matchMode: '=', value: `'${localDateTime + 'Z'}'` });
              }
              if (item.matchMode === 'dateBefore') {
                let localDateTime = moment(item.value).format('YYYY-MM-DDTHH:mm:ss');
                usedFilters.push({ key: filter.key, matchMode: '<', value: `'${localDateTime + 'Z'}'` });
              }
              if (item.matchMode === 'dateAfter') {
                let localDateTime = moment(item.value).format('YYYY-MM-DDTHH:mm:ss');
                usedFilters.push({ key: filter.key, matchMode: '>', value: `'${localDateTime + 'Z'}'` });
              }
            }
          })
        }
        //for domain
        if (filter.value.value && filter.value.value.length > 0) {
          const filterValue = filter.value
          if (filterValue.matchMode === 'in') {
            const valueArray = filterValue.value
            usedFilters.push({ key: filter.key, matchMode: '=', value: valueArray.map((value: any) => `${value}`).join(` OR ${filter.key}=`) });
          }
        };
      });
      return usedFilters
    }
  }
  const createFilters2 = (allFilters: any) => {
    if (allFilters.length > 0) {
      const matchMode: any = [];
      const filterKey: any = [];
      const value: any = [];
      allFilters.forEach((filter: any) => {
        if (filter.value.constraints && filter.value.constraints.length > 0) {
          filter.value.constraints.map((item: any) => {
            if (item.value) {
              if (item.matchMode === 'dateBefore' || item.matchMode === 'lt') {
                matchMode.push('before')
              }
              else if (item.matchMode === 'dateAfter' || item.matchMode === 'gt') {
                matchMode.push('after')
              }
              else {
                matchMode.push(item.matchMode)
              }
              filterKey.push(filter.key)
              value.push(item.value)
            }
          })
        }
        // for domain
        if (filter.value.value && filter.value.value.length > 0) {
          const filterValue = filter.value
          if (filterValue.matchMode === 'in') {
            const valueArray = filterValue.value
            matchMode.push(filterValue.matchMode)
            filterKey.push(filter.key)
            value.push(`(${valueArray.map((value: any) => value).join(';')})`)
          }
        };
      });
      return { matchMode: matchMode.join(','), filterKey: filterKey.join(','), value: value.join(',') }
    }
  }

  const searchInTapu = async (ilIlceMahFilters: any) => {
    const tapuFilters: any[] = []
    for (const filter of ilIlceMahFilters) {
      const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
      switch (filter.key) {
        case 'il_kodu':
          await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&cql_filter=adi${filter.matchMode}${filter.value}&outputFormat=application/json&typeName=il_usr&propertyname=adi,id`)
            .then((tapuIl: any) => {
              if (tapuIl && tapuIl.status === 200) {
                const idArray = []
                for (const feature of tapuIl.data.features) {
                  idArray.push(feature.properties.id)
                }
                if (idArray.length === 1) {
                  tapuFilters.push({ key: filter.key, matchMode: '=', value: idArray.length > 0 && idArray.map((arr: any) => arr).join(',') })
                }
                if (idArray.length > 1) {
                  tapuFilters.push({ key: filter.key, matchMode: ' in ', value: `(${idArray.length > 0 && idArray.map((arr: any) => arr).join(',')})` })
                }
              }
            })
          break;
        case 'ilce_kodu':
          await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&cql_filter=adi${filter.matchMode}${filter.value}&outputFormat=application/json&typeName=ilce_usr&propertyname=adi,id,il_kodu,ilce_kodu`)
            .then((tapuIlce: any) => {
              if (tapuIlce && tapuIlce.status === 200) {
                const idArray = []
                for (const feature of tapuIlce.data.features) {
                  idArray.push(feature.properties.ilce_kodu)
                }
                if (idArray.length === 1) {
                  tapuFilters.push({ key: filter.key, matchMode: '=', value: idArray.length > 0 && idArray.map((arr: any) => arr).join(',') })
                }
                if (idArray.length > 1) {
                  tapuFilters.push({ key: filter.key, matchMode: ' in ', value: `(${idArray.length > 0 && idArray.map((arr: any) => arr).join(',')})` })
                }
              }
            })
          break;
        case 'mahalle_kodu':
          const value = (filter.value as string).split('%')[0]
          if (value.length < 4) {
            (toast.current as any).show({ severity: 'error', summary: 'Error Message', detail: 'Lütfen minimum 3 karakter giriniz' });
          }
          await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&cql_filter=adi${filter.matchMode}${filter.value}&outputFormat=application/json&typeName=mahalle&propertyname=adi,id,ilce_id,mah_id`)
            .then((tapuMahalle: any) => {
              if (tapuMahalle && tapuMahalle.status === 200) {
                const idArray = []
                for (const feature of tapuMahalle.data.features) {
                  idArray.push(feature.properties.mah_id)
                }
                if (idArray.length === 1) {
                  tapuFilters.push({ key: filter.key, matchMode: '=', value: idArray.length > 0 && idArray.map((arr: any) => arr).join(',') })
                }
                if (idArray.length > 1) {
                  tapuFilters.push({ key: filter.key, matchMode: ' in ', value: `(${idArray.length > 0 && idArray.map((arr: any) => arr).join(',')})` })
                }
              }
            })
          break;

        default:
          break;
      }
    }

    return tapuFilters

  }

  const searchInTkgm = async (ilIlceMahFilters: any) => {
    const tapuFilters: any[] = []
    // setTapuFilters2([])
    for (const filter of ilIlceMahFilters) {
      const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url
      switch (filter.key) {
        case 'tkgm_il_kodu':
          await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&cql_filter=ad${filter.matchMode}${filter.value}&outputFormat=application/json&typeName=tapu_il&propertyname=ad,id`)
            .then((tapuIl: any) => {
              if (tapuIl && tapuIl.status === 200) {
                const idArray = []
                for (const feature of tapuIl.data.features) {
                  idArray.push(feature.properties.id)
                }
                if (idArray.length === 1) {
                  tapuFilters.push({ key: filter.key, matchMode: '=', value: idArray.length > 0 && idArray.map((arr: any) => arr).join(',') })
                }
                if (idArray.length > 1) {
                  tapuFilters.push({ key: filter.key, matchMode: ' in ', value: `(${idArray.length > 0 && idArray.map((arr: any) => arr).join(',')})` })
                }
              }
            })
          break;
        case 'tkgm_ilce_kodu':
          await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&cql_filter=ad${filter.matchMode}${filter.value}&outputFormat=application/json&typeName=tapu_ilce&propertyname=ad,id,ilid,featureid`)
            .then((tapuIlce: any) => {
              if (tapuIlce && tapuIlce.status === 200) {
                const idArray = []
                for (const feature of tapuIlce.data.features) {
                  idArray.push(feature.properties.id)
                }
                if (idArray.length === 1) {
                  tapuFilters.push({ key: filter.key, matchMode: '=', value: idArray.length > 0 && idArray.map((arr: any) => arr).join(',') })
                }
                if (idArray.length > 1) {
                  tapuFilters.push({ key: filter.key, matchMode: ' in ', value: `(${idArray.length > 0 && idArray.map((arr: any) => arr).join(',')})` })
                }
              }
            })
          break;
        case 'tkgm_mahalle_kodu':
          const value = (filter.value as string).split('%')[0]
          if (value.length < 4) {
            (toast.current as any).show({ severity: 'error', summary: 'Error Message', detail: 'Lütfen minimum 3 karakter giriniz' });
          }
          await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&cql_filter=ad${filter.matchMode}${filter.value}&outputFormat=application/json&typeName=tapu_mahalle&propertyname=ad,id,ilceid`)
            .then((tapuMahalle: any) => {
              if (tapuMahalle && tapuMahalle.status === 200) {
                const idArray = []
                for (const feature of tapuMahalle.data.features) {
                  idArray.push(feature.properties.id)
                }
                if (idArray.length === 1) {
                  tapuFilters.push({ key: filter.key, matchMode: '=', value: idArray.length > 0 && idArray.map((arr: any) => arr).join(',') })
                }
                if (idArray.length > 1) {
                  tapuFilters.push({ key: filter.key, matchMode: ' in ', value: `(${idArray.length > 0 && idArray.map((arr: any) => arr).join(',')})` })
                }
              }
            })
          break;

        default:
          break;
      }
    }
    return tapuFilters
  }


  const searchInSb = async (filter: any) => {
    if (filter && filter.length > 0) {
      const tapuFilters: any[] = []
      const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0].url

      await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&cql_filter=adi${filter[0].matchMode}${filter[0].value}&outputFormat=application/json&typeName=osb_sinir_usr&propertyname=adi,id`)
        .then((tapuIl: any) => {
          if (tapuIl && tapuIl.status === 200) {
            const idArray = []
            for (const feature of tapuIl.data.features) {
              idArray.push(feature.properties.id)
            }
            if (idArray.length === 1) {
              tapuFilters.push({ key: filter[0].key, matchMode: '=', value: idArray.length > 0 && idArray.map((arr: any) => arr).join(',') })
            }
            if (idArray.length > 1) {
              tapuFilters.push({ key: filter[0].key, matchMode: ' in ', value: `(${idArray.length > 0 && idArray.map((arr: any) => arr).join(',')})` })
            }
          }
        })
      return tapuFilters
    }
    else {
      return []
    }
  }
  
  return (
    <div className='table-container'>
      {!raporTable && <Toast ref={toast} />}
      {<DataTable
        ref={dt}
        selectionMode="single"
        filters={filters} size="small" header={header} filterDisplay="menu"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        stripedRows
        paginator
        value={values} resizableColumns
        responsiveLayout="scroll" loading={loading} columnResizeMode="fit"
        lazy onPage={onPage} totalRecords={totalRecords}
        onSort={onSort}
        sortField={(layer.name === 'parsel_usr' || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr' || layer.name === 'uip_1000' || layer.name === 'eb_uip_1000' || layer.name === 'tgb_uip_1000') ? sortFilter.sortBy : sortProperties.sortField}
        sortOrder={(layer.name === 'parsel_usr' || layer.name === 'parsel_pasif_usr' || layer.name === 'osb_sinir_usr' || layer.name === 'istatistik_bolge_duzey_2_usr' || layer.name === 'cografi_bolge_usr' || layer.name === 'tesvik_bolgeleri_usr' || layer.name === 'il_usr' || layer.name === 'uip_1000' || layer.name === 'eb_uip_1000' || layer.name === 'tgb_uip_1000') ? sortFilter.sortOrder === 0 ? -1 : 1 : sortProperties.sortOrder}
        onFilter={onFilter}
        emptyMessage='Yetkili olduğunuz data yoktur.'
        selection={selectedTableRow}
        first={first}
        onSelectionChange={(e: any) => { setSelectedTableRow(e.value) }}
        currentPageReportTemplate={`Showing ${first} to ${first + rows} of ${totalRecords}`}
        rows={rows}
        rowsPerPageOptions={[5, 10, 20, 50, 100]}
        paginatorLeft={zart}
      >
        {columns}
      </DataTable>}
    </div>
  )
}
